import ApiHttpHandler from "./apiHttpHandler";
const handler = new ApiHttpHandler();
const enableVPN = (droneId) => {
    return handler.post(`settings/${droneId}/enable-vpn`);
};
const disableVPN = (droneId) => {
    return handler.post(`settings/${droneId}/disable-vpn`);
};
const getSettings = (droneId) => {
    return handler.get(`settings/${droneId}`);
};
const saveSettings = (droneId, settings) => {
    return handler.put(`settings/${droneId}/save`, settings);
};
const publishSettings = (droneId) => {
    return handler.post(`settings/${droneId}/publish`);
};
const setDroneNewState = (droneId, state) => {
    return handler.put(`settings/${droneId}/set-new?state=${state}`);
};
const getVideoSettings = (droneId) => {
    return handler.get(`settings/${droneId}/video-settings`);
};
const saveVideoSettings = (droneId, model) => {
    return handler.put(`settings/${droneId}/video-settings`, model);
};
export default {
    enableVPN,
    disableVPN,
    getSettings,
    saveSettings,
    publishSettings,
    setDroneNewState,
    saveVideoSettings,
    getVideoSettings
};
